import { Link } from "react-router-dom";
import ctaImage from "../../assets/promo-cta.webp";

function CTA() {
  return (
    <section className="  section-spacing">
      <div className="section-container">
        <div className="w-full overflow-hidden rounded-[24px] border border-[#d7e1dc]   sm:rounded-[28px] lg:rounded-[30px]">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            
            {/* Left Content */}
            <div className="flex flex-col justify-center md:border-r px-6 py-9 sm:px-9 sm:py-12 md:px-12 md:py-14 lg:px-12 lg:py-16 xl:px-14">
            <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--hero-green)] sm:text-[12px] uppercase mb-3">
              PRE-VERIFICATION
            </p>
            <h2 className="font-bricolage text-[30px] font-semibold leading-[1.08] tracking-[-1.2px] text-[#071526] sm:text-[36px] md:text-[40px] lg:text-[40px] xl:text-[42px]">
              Know where your file stands,{" "}
              <span className="text-[var(--hero-green)]">
                before you apply.
              </span>
            </h2>

            <p className="mt-5 font-jakarta text-[14px] leading-[1.7] text-[#53656a] sm:text-[15px] md:text-[16px] lg:text-[17px]">
              Verification runs first, so the borrower hears one clear answer
              instead of three maybe calls.
            </p>

            <div className="mt-7">
              <Link
                to="/how-it-works"
                className="inline-flex min-h-[50px] items-center justify-center rounded-full bg-[var(--mint-green)] px-6 font-jakarta text-[15px] font-semibold text-[#071526] transition-all duration-200 hover:-translate-y-0.5 hover:opacity-90 outline-none focus:outline-none focus-visible:outline-none focus:ring-0 focus-visible:ring-0 active:outline-none select-none sm:min-h-[54px] sm:px-7 sm:text-[16px]"
              >
                See how it works
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative w-full overflow-hidden bg-white">
            <div className="aspect-[16/10] w-full sm:aspect-[16/9] lg:h-full lg:min-h-[350px] lg:aspect-auto">
              <img
                src={ctaImage}
                alt="Loan approval and verification illustration"
                className="h-full w-full object-cover object-center"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;